var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tab3',{attrs:{"previewOrPublish":_vm.previewOrPublish},on:{"openModalAlertText":_vm.openModalAlertText}}),_c('ModalAlertText',{attrs:{"textModal":_vm.textModal,"arrModal":_vm.arrStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }